import styled from 'styled-components'
import { maxWidth, minWidth, minMaxWidth, noTouch } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'
import { loadableStyles } from '@/assets/styles/global.css'

const WikiArticle = styled.article`
  --common-transition-time: 0.3s;

  position: relative;
  z-index: 0;
  min-height: 266px;
  transition: z-index 0s var(--common-transition-time);

  ${loadableStyles}

  ${noTouch()`
    &:hover {
      z-index: 1;
      transition: z-index 0s;
    }
  `}

  ${maxWidth(vars.breakpoints.tablet - 1)`
    min-height: 180px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    min-height: 225px;
  `}
`

WikiArticle.Link = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

WikiArticle.Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0 0 0 1px var(--color-border);
  transition: transform var(--common-transition-time) ease-in,
    box-shadow 0s var(--common-transition-time);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.06), 0px 0px 4px rgba(0, 0, 0, 0.04);
    opacity: 0;
    transition: opacity var(--common-transition-time) ease-in;
  }

  ${noTouch()`
    ${WikiArticle}:hover & {
      transform: scale(1.05);
      box-shadow: none;
      transition: transform var(--common-transition-time) ease-in,
        box-shadow var(--common-transition-time);

      &:after {
        opacity: 1;
      }
    }
  `}
`

WikiArticle.Content = styled.div`
  padding: 28px 32px 32px;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 22px 20px 26px;
  `}
`

WikiArticle.Title = styled.h3`
  margin-bottom: 18px;
  font-weight: normal;
  font-size: 20px;
  line-height: 1.4;
  color: var(--color-main);

  ${maxWidth(vars.breakpoints.tablet - 1)`
    padding-right: 30px;
    font-size: 18px;
  `}

  ${WikiArticle}:hover & {
    ${minWidth(vars.breakpoints.sDesktop + 1)`
      padding-right: 56px;
    `}

    ${minMaxWidth(vars.breakpoints.tablet, vars.breakpoints.sDesktop)`
      padding-right: 46px;
    `}
  }
`

WikiArticle.Description = styled.p`
  --wa-desc-lines: 6;

  display: -webkit-box;
  max-height: calc(14px * 1.6 * var(--wa-desc-lines, 6));
  -webkit-line-clamp: var(--wa-desc-lines, 6);
  -moz-line-clamp: var(--wa-desc-lines, 6);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-extra);

  ${maxWidth(vars.breakpoints.tablet - 1)`
    --wa-desc-lines: 4;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    --wa-desc-lines: 6;
  `}
`

WikiArticle.Arrow = styled.div`
  --arrow-btn-width: 56px;
  --arrow-btn-shadow-content: none;

  position: absolute;
  top: 18px;
  right: 14px;
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity var(--common-transition-time) ease-in,
    transform var(--common-transition-time) ease-in;

  ${maxWidth(vars.breakpoints.sDesktop)`
    --arrow-btn-width: 46px;
    top: 16px;
    right: 16px;
  `}

  ${maxWidth(vars.breakpoints.tablet - 1)`
    --arrow-btn-width: 60px;
    --arrow-btn-bg: rgba(0, 0, 0, 0);
    --arrow-btn-color: var(--color-decor);
    top: 5px;
    right: 0;
    opacity: 1;
    transform: none;
  `}

  ${noTouch()`
    ${WikiArticle}:hover & {
      opacity: 1;
      transform: none;
    }
  `}
`

export default WikiArticle
